import template from './insuranceSummaryOfCoverModal.html';
import './style.scss';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    profilerData: '<',
    modalInstance: '<',
  },
};
